import React, { useEffect, useState } from "react";
import DateBox, { IDateBoxOptions } from "devextreme-react/date-box";
import { GetNewId } from "shared/utility/CommonUtility";
import { getControlRadius } from "shared/utility/ControlUtility";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import "./styles/Datepicker.css";
import BaseControlProps from "interfaces/BaseControlProps";
import { Validator, RequiredRule } from "devextreme-react/validator";
import moment, { Moment } from "moment";

interface Props {
  className?: string;
  highlightedDates?: Moment[];
}

export default function Datepicker(
  props: Props & IDateBoxOptions & BaseControlProps
) {
  const {
    className: propClassNames,
    highlightedDates,
    required,
    label,
    id,
    ...rest
  } = props;
  const [validatorRules, setValidatorRules] = useState<any>([]);

  useEffect(() => {
    const setValidationRules = () => {
      const rules = [];
      if (required) {
        const rule = (
          <RequiredRule
            key={`${GetNewId()}-${id}`}
            message={`${label} is required.`}
          />
        );
        rules.push(rule);
      }

      setValidatorRules(rules);
    };

    setValidationRules();
  }, [id, label, required]);

  const getClassNames = () => {
    const classNames = `prom-control h-10 border-1.5 border-silver outline-none ${getControlRadius(
      ControlSize.Large
    )}`;
    return propClassNames ? `${classNames} ${propClassNames}` : classNames;
  };

  const HighlightedDaysCellTemplate = (data: any, index: any, element: any) => {
    let myCustomMarkup = data.text;
    if (
      (highlightedDates || []).find((date: Moment) =>
        date.isSame(moment(data.date), "date")
      )
    ) {
      element.classList.add("highlightedDate");
    }
    return myCustomMarkup;
  };

  return (
    <div className="prom-datepicker">
      <DateBox
        {...rest}
        className={getClassNames()}
        calendarOptions={{ cellTemplate: HighlightedDaysCellTemplate }}
      >
        <Validator>{validatorRules}</Validator>
      </DateBox>
    </div>
  );
}
